import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";  
const KidsCorner = () => {  
  useEffect(() => {
    document.title = 'Kids Corner - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                     
                    <li>Kids Corner</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">  
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mx-auto d-block">
                            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/coming-soon.png" className="img-fluid" alt="sfxhisar"/></LazyLoad>
                        </div>  
                   </div>
                    </div>  
           </section>
           <Footer/>
        </>
    );
}

export default KidsCorner;
